<template>
  <div>
    <div class="pc" v-if="isDesktop">
      <swiper-container
        ref="mySwiper"
        :slides-per-view="1"
        navigation="true"
        pagination="true"
        :autoplay-delay="3000"
        :autoplay-disable-on-interaction="false"
        loop="true"
        v-if="slides.length"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="http + slide.attachfile" alt width="100%" />
        </swiper-slide>
      </swiper-container>
    </div>
    <div v-else class="move">
      <swiper-container
        ref="mySwiper"
        :slides-per-view="1"
        pagination="true"
        :autoplay-delay="3000"
        :autoplay-disable-on-interaction="false"
        loop="true"
        v-if="move_img.length"
      >
        <swiper-slide v-for="(slide, index) in move_img" :key="index">
          <img :src="http + slide.attachfile" alt width="100%" />
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import method from "@/utils/Untitl.js";
import "swiper/css";
import "swiper/css/effect-fade";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      slides: [],
      move_img: [],
      http: process.env.VUE_APP_BASE_API,
      isDesktop: window.innerWidth > 428,
      // mySwiper: null, // 用于存储 Swiper 实例
    };
  },
  // setup() {
  //   const spaceBetween = 1;
  //   const onProgress = (e) => {
  //     const [swiper, progress] = e.detail;
  //     console.log(progress);
  //   };

  //   const onSlideChange = (e) => {
  //     console.log("slide changed");
  //   };

  //   return {
  //     spaceBetween,
  //     onProgress,
  //     onSlideChange,
  //   };
  // },
  mounted() {
    if (localStorage.getItem("isPageRefreshed")) {
      // console.log("刷新");
      // 清除标记，避免下次加载误判
      // localStorage.removeItem("isPageRefreshed");
    }
    // window.addEventListener("resize", this.handleResize);
    // 监听页面即将卸载事件
    // window.addEventListener("beforeunload", this.setRefreshFlag);
    this.getIndex();
  },
  methods: {
    async getIndex() {
      const res = await method.index();
      // console.log(res);
      if (res.code === 1) {
        this.slides = res.data.pc_ads;
        this.move_img = res.data.mobile_ads;
      }
    },
  },
  watch: {
    slides() {
      this.$nextTick(() => {
        const swiper = this.$refs.mySwiper?.swiper;
        if (swiper) {
          swiper.update(); // 重新计算 slide 数量
          swiper.loopCreate(); // 重新创建 loop 副本
        }
      });
    },
    move_img() {
      this.$nextTick(() => {
        const swiper = this.$refs.mySwiper?.swiper;
        if (swiper) {
          swiper.update(); // 重新计算 slide 数量
          swiper.loopCreate(); // 重新创建 loop 副本
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/pc/swiper_in.scss";
@import "../assets/css/move/swiper_in.scss";
</style>